"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WhitelistDoiPage = exports.BlacklistDoiPage = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var Base = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, _constants.ACTIVE, null), (0, _defineProperty2.default)(_ref, _constants.ID, null), (0, _defineProperty2.default)(_ref, _constants.INCLUSION_STATE, null), (0, _defineProperty2.default)(_ref, _constants.PAGE_ID, null), _ref), _constants.DOI_PAGES);

var DoiPage =
/*#__PURE__*/
function (_Base) {
  (0, _inherits2.default)(DoiPage, _Base);

  function DoiPage(data) {
    (0, _classCallCheck2.default)(this, DoiPage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DoiPage).call(this, Object.assign(data, (0, _defineProperty2.default)({}, _constants.ID, parseInt(data[_constants.PAGE_ID], 10)))));
  }

  return DoiPage;
}(Base);

var BlacklistDoiPage =
/*#__PURE__*/
function (_DoiPage) {
  (0, _inherits2.default)(BlacklistDoiPage, _DoiPage);

  function BlacklistDoiPage(pageId) {
    var _getPrototypeOf$call;

    (0, _classCallCheck2.default)(this, BlacklistDoiPage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlacklistDoiPage).call(this, (_getPrototypeOf$call = {}, (0, _defineProperty2.default)(_getPrototypeOf$call, _constants.PAGE_ID, pageId.toString()), (0, _defineProperty2.default)(_getPrototypeOf$call, _constants.INCLUSION_STATE, _constants.BLACKLIST), (0, _defineProperty2.default)(_getPrototypeOf$call, _constants.ACTIVE, true), _getPrototypeOf$call)));
  }

  return BlacklistDoiPage;
}(DoiPage);

exports.BlacklistDoiPage = BlacklistDoiPage;

var WhitelistDoiPage =
/*#__PURE__*/
function (_DoiPage2) {
  (0, _inherits2.default)(WhitelistDoiPage, _DoiPage2);

  function WhitelistDoiPage(pageId) {
    var _getPrototypeOf$call2;

    (0, _classCallCheck2.default)(this, WhitelistDoiPage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WhitelistDoiPage).call(this, (_getPrototypeOf$call2 = {}, (0, _defineProperty2.default)(_getPrototypeOf$call2, _constants.PAGE_ID, pageId.toString()), (0, _defineProperty2.default)(_getPrototypeOf$call2, _constants.INCLUSION_STATE, _constants.WHITELIST), (0, _defineProperty2.default)(_getPrototypeOf$call2, _constants.ACTIVE, true), _getPrototypeOf$call2)));
  }

  return WhitelistDoiPage;
}(DoiPage);

exports.WhitelistDoiPage = WhitelistDoiPage;
var _default = DoiPage;
exports.default = _default;